import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { TreeComponent } from './tree.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTreeModule],
  exports: [TreeComponent],
  declarations: [TreeComponent],
  providers: []
})
export class TreeModule {}
